import { render, staticRenderFns } from "./PhraseAnalyser.vue?vue&type=template&id=39f19f91&scoped=true"
import script from "./PhraseAnalyser.vue?vue&type=script&lang=js"
export * from "./PhraseAnalyser.vue?vue&type=script&lang=js"
import style0 from "./PhraseAnalyser.vue?vue&type=style&index=0&id=39f19f91&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./PhraseAnalyser.vue?vue&type=style&index=2&id=39f19f91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f19f91",
  null
  
)

export default component.exports